export const toQueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');
};

export const formatText = (template, ...args) => {
  return template.replace(/%(\d+)\$@/g, (match, index) => {
    const i = Number(index) - 1;
    return i >= 0 && i < args.length ? args[i] : match;
  });
};
